"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTENT_TYPE_LOOKUP = void 0;
exports.CONTENT_TYPE_LOOKUP = new Map([
    ["jpg", "image/jpeg"],
    ["jpeg", "image/jpeg"],
    ["gif", "image/gif"],
    ["png", "image/png"],
]);
